import loadable from '@loadable/component'

export default [
  {
    path: '/guildsettled',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GuildSettled" */ '~/pages/GuildSettled'
        )
    ),
  },
  {
    path: '/guildsettled/inviteguild/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GuildSettled--InviteGuild" */ '~/pages/GuildSettled/InviteGuild'
        )
    ),
  },
]
